import { render, staticRenderFns } from "./startTomasonIndustrial.vue?vue&type=template&id=38d86812&"
import script from "./startTomasonIndustrial.vue?vue&type=script&lang=js&"
export * from "./startTomasonIndustrial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports